<template>
    <div class="tournament-awards-card">
        <h2 v-if="showAwards" class="title">{{ $t('awards_TournamentAwardsCard.title', { total: formattedTotalAwardValue }) }}</h2>
        <span v-if="showAwards" class="disclaimer">({{ $t('awards_TournamentAwardsCard.disclaimer') }})</span>
        <div v-if="showAwards" class="carousel">
            <div class="carousel-inner" :style="carouselStyle">
                <div class="carousel-item" v-for="(award) in awards" :key="award.rank">
                    <img
                        v-if="getMedalSrc(award.rank)"
                        :src="getMedalSrc(award.rank)"
                        class="award-medal-img"
                        :class="getMedalClass(award.rank)"
                        :alt="`Medal ${award.rank}`"
                    />
                    <i v-else class="fa fa-regular fa-medal" :class="getMedalClass(award.rank)" ></i>
                    <b :class="getMedalClass(award.rank)" class="award-name">{{truncate(award.title, 15) }}</b>
                    <span class="disclaimer">{{ truncate(award.description, 35) }}</span>
                    <b class="award-rank">{{ getOrdinalRank(award.rank) }} {{ $t('place') }}</b>
                </div>
            </div>
        </div>
        <div v-if="false" class="actions">
            <button v-if="faqsUrl" class="faqs-btn" @click="goToFAQs">{{ $t('viewFAQs') }}</button>
            <button v-if="false" class="rules-btn" @click="goToRules">{{ $t('viewRules') }}</button>
        </div>
        <hr v-if="showSponsor && ((partnerLogo && partnerLogo.length) || partnerLogoPreview) && showAwards" />
        <div class="partner" v-if="showSponsor && ((partnerLogo && partnerLogo.length) || partnerLogoPreview) && showAwards">
            <b class="thanks-to-txt">{{ $t('thanksTo') }}</b>
            <!-- <img :src="partnerLogo" alt="partner-logo" /> -->
            <div class="partner-logo-wrap">
                <div v-if="partnerLogoPreview === null" class="partner-logo-loading">
                 <!-- opcional: skeleton / loading -->
                </div>

                <img
                     v-else-if="partnerLogoPreview"
                    :src="partnerLogoPreview"
                    alt="partner-logo"
                    class="partner-logo"
                />
            </div>

        </div>
    </div>
</template>

<script>
    import Repository from "@/repositories/tournament"; 

export default {
    name: 'TournamentAwardsCard',
    props: {
        showAwards: { type: Boolean, default: true },
        showSponsor: { type: Boolean, default: true },
        awards: {
            type: Array,
            required: true,
            default: () => [
                { rank: 1, name: 'Default Award 1', value: 100 },
                { rank: 2, name: 'Default Award 2', value: 200 },
                { rank: 3, name: 'Default Award 3', value: 300 },
            ],
        },
        faqsUrl: {
            type: String,
            required: false,
        },
        rulesUrl: {
            type: String,
            required: false,
        },
        partnerLogo: {
            type: String,
            required: false,
            default: 'https://hub.swiset.com/wp-content/uploads/2024/01/Swiset-Logo-SVG-for-Light.png',
        },
    },
    data() {
        return {
            currentIndex: 0,
                partnerLogoPreview: null, 
                isInitializing: false,
        };
    },
    computed: {
        totalAwardValue() {
            return this.awards.reduce((total, award) => {
                if (award.estimatedValue) {
                    return Number(total) + Number(award.estimatedValue);
                }
            }, 0);
        },
        formattedTotalAwardValue() {
            return this.totalAwardValue ? this.totalAwardValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : Number(0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        carouselStyle() {
            return {
                transform: `translateX(-${this.currentIndex * 100}%)`,
                transition: 'transform 0.5s ease-in-out',
            };
        },
        shouldShowSponsor() {
            const selectedFeatures = this.$store.state.tournament?.selectedFeatures;
            if (!selectedFeatures || !Array.isArray(selectedFeatures)) {
                return true;
            }
            return selectedFeatures.includes('TOURNAMENT_RANKING_SPONSORED');
        },

        medalTypeFromState() {
            return this.$store.state.tournament?.tournamentSettings.medalType || "default";
        },
        normalizedMedalType() {
            const t = (this.medalTypeFromState || "default").toLowerCase();
            const allowed = ["default", "3d", "neon", "retro"];
            return allowed.includes(t) ? t : "default";
        },

    },
    methods: {
        async initPartnerLogo() {
            if (!this.showSponsor || !this.shouldShowSponsor) {
            this.partnerLogoPreview = null;
            return;
        }
        this.isInitializing = true;
        this.partnerLogoPreview = null;
        const tournamentId = this.$store.state.tournament?.tournamentId;
        const isDark = !!this.$vuetify?.theme?.dark;

        try {
            if (tournamentId) {
                const res = await Repository.getTournamentBranding(tournamentId);
                const branding = res?.data || {};
                const newUrl = isDark
                    ? branding.dark?.fullLogo
                    : branding.light?.fullLogo;

                if (newUrl && typeof newUrl === "string" && newUrl.length > 0) {
                    this.partnerLogoPreview = newUrl;
                    return;
                }
            }
        }   catch (e) {
             console.warn("Branding new endpoint failed, falling back:", e);
                }

      try {
        if (!this.partnerLogo) {
          this.partnerLogoPreview = null;
          return;
        }
    
        const r = await Repository.getTournamentBrandingImage(this.partnerLogo);
        if (r?.status < 400 && r?.data) {
          this.partnerLogoPreview = r.data;
        } else {

          this.partnerLogoPreview = this.partnerLogo;
        }
      } catch (e) {
        console.error("Error fetching partner logo fallback:", e);
        this.partnerLogoPreview = this.partnerLogo || null;
      } finally {
        this.isInitializing = false;
      }
    },
        getMedalSrc(rank) {
          if (![1, 2, 3].includes(rank)) return null;
        
          const folder = this.normalizedMedalType || "default";
            try {
            return require(`@/assets/icons/${folder}/Medal-${rank}.png`);
          } catch (e) {
            return null;
          }
        },
        startCarousel() {
            setInterval(() => {
                this.currentIndex = (this.currentIndex + 1) % this.awards.length;
            }, 5000);
        },
        getOrdinalRank(rank) {
            const suffixes = this.$i18n.locale === 'es' ? ['º', 'º', 'º', 'º'] : ['th', 'st', 'nd', 'rd'];
            const v = rank % 100;
            return rank + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
        },
        getMedalClass(rank) {
            if (rank === 1) return 'gold';
            if (rank === 2) return 'silver';
            if (rank === 3) return 'bronze';
            return '';
        },
        goToFAQs() {
            window.open(this.faqsUrl, 'self');
        },
        goToRules() {
            window.open(this.rulesUrl, 'self');
        },
        parseValueFromTitle(title) {
            const match = title.match(/\$([\d,.]+)/);
            if (match) {
                const value = match[1].replace(/[,.]/g, '');
                return parseInt(value, 10);
            }
            return null;
        },
        isDarkMode() {
            return !!this.$vuetify?.theme?.dark;
        },
        truncate(text, max = 35) {
            if (!text) return '';
            const s = String(text).trim();
            if (s.length <= max) return s;
            return s.slice(0, max - 1) + '…';
        },
    },
    mounted() {
        this.startCarousel();
        this.initPartnerLogo();

    },
    watch: {
      partnerLogo() {
        this.initPartnerLogo();
      },
      showSponsor() {
        this.initPartnerLogo();
      },
    "$vuetify.theme.dark"() {
        this.initPartnerLogo();
        },
    }


};
</script>


<style scoped lang="scss">
.partner-logo-wrap {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.partner-logo {
  max-width: 250px;
  max-height: 70px;
  object-fit: contain;
}

.partner-logo-loading {
  width: 250px;
  height: 70px;
  border-radius: 10px;
  background: rgba(0,0,0,0.06);
}

#broker-app {
    .tournament-awards-card h2 {
        font-family: 'Avenir', sans-serif !important;
        font-weight: bold;
        font-size: 24px !important;
    }
}

.tournament-awards-card {
    text-align: center;
    border: 1px solid #9a9a9a;
    border-radius: 15px;
    background-color: var(--v-fullWhite-base);
    font-family: 'Avenir', sans-serif;
    display: flex;
    flex-direction: column;
    padding: 18px 20px;
    justify-content: center;
    margin-left: auto;

    h2 {
        font-family: 'Avenir', sans-serif !important;
        font-weight: bold;
        font-size: 24px;
    }

    .disclaimer {
        font-size: 14px;
        color: #9a9a9a;
        margin-bottom: 6px;
    }

    .actions {
        display: flex;
        justify-content: space-between;
        margin-top: 18px;

        .faqs-btn,
        .rules-btn {
            border: none;
            padding: 10px 30px;
            border-radius: 5px;
            font-size: 14px;
            cursor: pointer;
        }

        .faqs-btn {
            width: 100%;
            background-color: var(--v-progressBarBackground-base);
        }

        .rules-btn {
            background-color: var(--v-mainGreen-base);
            color: black;
        }
    }

    hr {
        border: 1px solid #9a9a9a;
        opacity: 0.6;
        margin-top: 32px;
        margin-bottom: 32px;
    }

    .partner {
        display: flex;
        flex-direction: column;
        align-items: center;

        .thanks-to-txt {
            font-size: 18px;
        }

        img {
            width: 250px;
            margin-top: 10px;
        }
    }
}

.carousel {
    position: relative;
    height: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.carousel-inner {
    display: flex;
    height: 100%;
    width: 100%;
}

.carousel-item {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    text-align: center;
    padding: 0 10px;

    .award-medal-img {
        width: 48px;
        height: 48px;
        object-fit: contain;
        display: block;
    }


    i {
        font-size: 48px;
    }

    .award-name {
        font-size: 24px;
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .award-description{
        font-size: 14px;
        max-width: 200px;
        padding-bottom: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .award-rank {
        line-height: 1;
        font-size: 20px;
        margin-top: 0px;
        color: #9a9a9a;
    }
}

.gold {
    color: gold;
}

.silver {
    color: silver;
}

.bronze {
    color: #cd7f32;
}
</style>